module.exports = __webpack_public_path__ + "img/everTrust-logo-home.327a32ff.png";